import React, {  useEffect, useState } from 'react';
import styled from 'styled-components/macro';

import MobileNavMenu from './MobileNavMenu';
import { Burger } from '../nucleoIcons';
import { colors } from '../../styles/constants';

interface BurgerButtonProps {
    initial?: boolean;
}

const BurgerButton = (
    {
        initial = false,
    }: BurgerButtonProps
) => {
    const [open, setOpen] = useState(initial);

    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [open]);

    return (
        <>
            <Wrapper onClick={() => setOpen(!open)}>
                <Burger height={'25px'} width={'25px'} />
            </Wrapper>
            {open && <MobileNavMenu onClose={() => setOpen(false)} />}
        </>
    );
};

const Wrapper = styled.div`
    display: none;
    cursor: pointer;
    color: #fff;

    @media (max-width: 768px) {
        display: flex;
        align-self: center;
        margin-right: 25px;
    }
`;

export default BurgerButton;
